<template>
  <div id="m_upload">
    <div
      class="m_upload_image"
      v-for="(item, index) in imgSrcArray"
      :key="index"
    >
      <img :src="item" v-if="item" />
      <div class="m_upload_actions">
        <i class="el-icon-search" @click="handlePreviewImage(index)"></i>
        <i class="el-icon-delete" @click="handleDeleteImage(index)"></i>
      </div>
    </div>
    <div class="m_upload_uploader" v-if="imgSrcArray.length < 5">
      <i class="el-icon-plus"></i>
      <el-upload
        :before-upload="handleBeforeUploadImage"
        :on-success="handleImageUploadSuccess"
        :show-file-list="false"
        :headers="headers"
        action="/declare/Upload/image"
      ></el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "multipleImageUpload",
  props: {
    imgSrcArray: {
      type: Array,
      required: true,
      default: () => [],
    },
    sizeLimit: {
      // 2026.08.31，之前判断上传图片单位为M，现在又有判断单位为kb的要求，所以底下判断做了处理
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      headers: {},
    };
  },
  created() {
    this.headers = {
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    handleBeforeUploadImage(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.warning("只能上传JPG或PNG格式的图片！");
        return false;
      } else if (this.sizeLimit !== null) {
        if (file.size > 1024 * this.sizeLimit) {
          this.$message.warning(
            "上传的图片大小不可超过" + this.sizeLimit + "k"
          );
          return false;
        }
      } else if (this.sizeLimit === null) {
        if (file.size > 1024 * 1024 * 4) {
          this.$message.warning("上传的图片大小不可超过4M");
          return false;
        }
      }
      this.$emit("handleUploading");
      return true;
    },
    handleImageUploadSuccess(res) {
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.$emit("handleUploadSuccess", res.data.uri);
      } else {
        this.$emit("handleUploadSuccess");
        this.$message.error(res.msg);
      }
    },
    handlePreviewImage(index) {
      this.$emit("handlePreviewImage", index);
    },
    handleDeleteImage(index) {
      this.$confirm("确定要删除已经上传的图片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("handleDeleteImage", index);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
#m_upload {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .m_upload_image {
    width: 160px;
    height: 100%;
    margin-right: 20px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .m_upload_actions {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
      visibility: hidden;
      i {
        font-size: 30px;
        color: #409eef;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
  .m_upload_image:hover {
    .m_upload_actions {
      visibility: visible;
    }
  }
  .m_upload_uploader {
    width: 160px;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    .el-icon-plus {
      margin: 0;
      font-size: 32px;
      color: #d9d9d9;
    }
    > div:last-child {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      /deep/ .el-upload {
        width: 100%;
        height: 100%;
      }
    }
  }
  .m_upload_uploader:hover {
    border-color: #e40080;
    .el-icon-plus {
      color: #e40080;
    }
  }
}
</style>